const nav=document.querySelector('.nav');
    const navBrand=document.querySelector('.brand');
    const mobileNavMenu=document.querySelector('.mobile-nav-menu');
    const mobileNavQuery=matchMedia('(max-width:800px)');
    const setMobileMenu=open=>{nav.classList.toggle('menu-open',open);navBrand.setAttribute('aria-expanded',String(open))};
    navBrand.addEventListener('click',event=>{if(!mobileNavQuery.matches)return;event.preventDefault();setMobileMenu(!nav.classList.contains('menu-open'))});
    mobileNavMenu.addEventListener('click',event=>{if(event.target.closest('a'))setMobileMenu(false)});
    document.addEventListener('click',event=>{if(mobileNavQuery.matches&&nav.classList.contains('menu-open')&&!nav.contains(event.target))setMobileMenu(false)});
    document.addEventListener('keydown',event=>{if(event.key==='Escape')setMobileMenu(false)});
    mobileNavQuery.addEventListener('change',()=>setMobileMenu(false));
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals=[...document.querySelectorAll('.reveal')];
    if(reduced){reveals.forEach(el=>el.classList.add('visible'))}
    else{
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('visible');observer.unobserve(entry.target)}}),{threshold:.12});
      reveals.forEach((el,index)=>{el.style.transitionDelay=`${Math.min((index%4)*75,225)}ms`;observer.observe(el)});
      const scopeGrid=document.querySelector('.scope-grid');
      const scopeObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){scopeGrid.classList.add('cards-visible');setTimeout(()=>scopeGrid.classList.add('cards-settled'),1100);scopeObserver.disconnect()}}),{threshold:.18});
      scopeObserver.observe(scopeGrid);
      const manifesto=document.querySelector('.manifesto');
      const manifestoBrand=document.querySelector('.manifesto-brand');
      const brandLogo=document.querySelector('.manifesto-brand img');
      const brandWords=[...document.querySelectorAll('.brand-statement span')];
      const lightTargets=[brandLogo,...brandWords];
      const cta=document.querySelector('.cta');
      const ctaHeading=document.querySelector('.cta h2');
      const clamp=(value,min,max)=>Math.min(Math.max(value,min),max);
      const smooth=value=>value*value*(3-2*value);
      const documentTop=element=>{let top=0,node=element;while(node){top+=node.offsetTop;node=node.offsetParent}return top};
      const update=()=>requestAnimationFrame(()=>{
        const y=scrollY,vh=innerHeight;
        const pageProgress=clamp(y/(document.documentElement.scrollHeight-vh),0,1);
        let ambientX=72-pageProgress*42;
        let ambientY=28+pageProgress*48;
        let ambientW=56;
        let ambientH=55;
        let ambientOpacity=.8;

        const manifestoTop=documentTop(manifesto);
        const manifestoDistance=Math.max(manifesto.offsetHeight-vh,1);
        const manifestoProgress=clamp((y-manifestoTop)/manifestoDistance,0,1);
        const manifestoRect=manifesto.getBoundingClientRect();
        const manifestoEnter=smooth(clamp((vh*.92-manifestoRect.top)/(vh*.7),0,1));
        const manifestoExit=smooth(clamp((vh*.12-manifestoRect.bottom)/(vh*.72),0,1));
        const manifestoInfluence=manifestoEnter*(1-manifestoExit);
        const stageFloat=manifestoProgress*(lightTargets.length-1);
        const stageFrom=Math.floor(stageFloat);
        const stageTo=Math.min(stageFrom+1,lightTargets.length-1);
        const stageMix=smooth(stageFloat-stageFrom);
        const fromRect=lightTargets[stageFrom].getBoundingClientRect();
        const toRect=lightTargets[stageTo].getBoundingClientRect();
        const targetX=(fromRect.left+fromRect.width*.5)*(1-stageMix)+(toRect.left+toRect.width*.5)*stageMix;
        const targetY=(fromRect.top+fromRect.height*.5)*(1-stageMix)+(toRect.top+toRect.height*.5)*stageMix;
        const brandRect=manifestoBrand.getBoundingClientRect();
        const localLightX=clamp((targetX-brandRect.left)/Math.max(brandRect.width,1)*100,7,93);
        const localLightY=clamp((targetY-brandRect.top)/Math.max(brandRect.height,1)*100,8,92);

        manifestoBrand.style.setProperty('--local-light-x',`${localLightX}%`);
        ambientX+=(clamp(targetX/innerWidth*100,0,100)-ambientX)*manifestoInfluence;
        ambientY+=(clamp(targetY/vh*100,0,100)-ambientY)*manifestoInfluence;
        ambientW+=(25-ambientW)*manifestoInfluence;
        ambientH+=(31-ambientH)*manifestoInfluence;
        ambientOpacity+=(1.04-ambientOpacity)*manifestoInfluence;
        manifestoBrand.style.setProperty('--local-light-y',`${localLightY}%`);
        manifestoBrand.style.setProperty('--local-line-y',`${localLightY}%`);

        lightTargets.forEach((target,index)=>{
          const level=1-clamp(Math.abs(index-stageFloat),0,1);
          if(index===0){
            target.style.setProperty('--logo-stage-opacity',String(.34+level*.66));
            target.style.setProperty('--logo-stage-scale',String(.97+level*.045));
            target.style.setProperty('--logo-stage-brightness',String(.78+level*.5));
          }else{
            target.style.setProperty('--word-opacity',String(.25+level*.75));
            target.style.setProperty('--word-y',`${(1-level)*7}px`);
            target.style.setProperty('--word-scale',String(.985+level*.02));
            target.style.setProperty('--word-shadow',`${level*38}px`);
          }
        });

        const ctaRect=cta.getBoundingClientRect();
        const ctaHeadingRect=ctaHeading.getBoundingClientRect();
        const ctaLightProgress=clamp((vh*.96-ctaRect.top)/(vh*.78),0,1);
        const ctaLightEase=smooth(ctaLightProgress);
        const ctaTargetX=(ctaHeadingRect.left+ctaHeadingRect.width*.5)/innerWidth*100;
        const ctaTargetY=(ctaHeadingRect.top+ctaHeadingRect.height*.5)/vh*100;
        ambientX+=(ctaTargetX-ambientX)*ctaLightEase;
        ambientY+=(ctaTargetY-ambientY)*ctaLightEase;
        ambientW+=(39-ambientW)*ctaLightEase;
        ambientH+=(43-ambientH)*ctaLightEase;
        ambientOpacity+=(1.12-ambientOpacity)*ctaLightEase;
        manifestoBrand.style.setProperty('--local-light-opacity',String(.72*(1-ctaLightEase)));
        manifestoBrand.style.setProperty('--local-line-opacity',String(.34*(1-ctaLightEase)));
        cta.style.setProperty('--cta-glow-opacity',String(ctaLightEase*.72));
        cta.style.setProperty('--cta-scale',String(.68+ctaLightEase*.54));
        cta.style.setProperty('--cta-text-glow',String(ctaLightEase*.42));

        document.documentElement.style.setProperty('--ambient-x',`${ambientX}%`);
        document.documentElement.style.setProperty('--ambient-y',`${ambientY}%`);
        document.documentElement.style.setProperty('--ambient-w',`${ambientW}vw`);
        document.documentElement.style.setProperty('--ambient-h',`${ambientH}vh`);
        document.documentElement.style.setProperty('--ambient-opacity',String(ambientOpacity));
        document.documentElement.style.setProperty('--portrait-y',`${Math.min(y*.035,22)}px`);
      });
      addEventListener('scroll',update,{passive:true});update();
    }
